<template>
  <div v-if="showProvider">
    <div
      class="popup-wrap popup-lobby"
      :class="{ active: showProvider }"
    >
      <div class="popup-box">
        <div class="content">
          <div class="top">
            <div class="title">
              <h3>{{ $t("Bao.provider") }}</h3>
              <a class="popup-close" @click="hide"><i class="fa-solid fa-xmark" /></a>
            </div>
            <div class="search-input">
              <input v-model="searchText" type="text" :placeholder="$t('Bao.find_provider')">
            </div>
          </div>
          <!-- 品牌搜尋-推薦品牌 -->
          <div class="search-result">
            <div
              v-for="(item, key) in filterResult"
              :key="key"
              class="search-game-info"
              :class="{ active: item.id === selectedProvider.id }"
              @click="apply(item)"
            >
              <div class="search-game-text">
                <i>
                  <picture><img :src="item.image" alt=""></picture>
                </i>
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-lobby">
      <div class="top">
        <div class="title">
          <h3>{{ $t("Bao.provider") }}</h3>
          <a class="popup-close" @click="hide"><i class="fa-solid fa-xmark" /></a>
        </div>
        <div class="search-input">
          <input
            ref="searchInput"
            v-model="searchText"
            type="text"
            :placeholder="$t('Bao.find_provider')"
          >
        </div>
      </div>
      <div class="content">
        <div class="search-result">
          <div
            v-for="(item, key) in filterResult"
            :key="key"
            class="search-game-info"
            :class="{ active: item.id === selectedProvider.id }"
            @click="apply(item)"
          >
            <div class="search-game-text">
              <i>
                <picture><img :src="item.image" alt=""></picture>
              </i>
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchText: '',
      selectedProvider: {}
    }
  },
  computed: {
    filterResult() {
      if (this.searchText === '') return this.$store.getters.gameProvider
      else {
        return this.$store.getters.gameProvider.filter((provider) => {
          const providerNameLower = provider.name.toLowerCase()
          const searchTextLower = this.searchText.toLowerCase()
          return providerNameLower.includes(searchTextLower)
        })
      }
    },
    showProvider() {
      return this.$store.state.brand.showProvider
    }
  },
  watch: {
    showProvider(newVal) {
      if (!newVal) {
        this.searchText = ''
      } else {
        this.$nextTick(() => {
          this.$refs.searchInput.focus()
        })
      }
    }
  },
  methods: {
    apply(item) {
      this.selectedProvider = item
      this.$emit('change-provider', this.selectedProvider)
      this.selectedProvider = {}
      this.searchText = ''
      this.$store.commit('SET_SHOW_PROVIDER', false)
    },
    hide() {
      this.$store.commit('SET_SHOW_PROVIDER', false)
      this.selectedProvider = {}
      this.searchText = ''
      this.errors.clear()
    },
    clearSearchText() {
      this.searchText = ''
    }
  }
}
</script>

